let RE = {
    game:'wittledefender',

    url: '',  //跳转地址
    iosUrl: 'https://apps.apple.com/us/app/wittle-defender/id6502815032',  //默认地址
    AndUrl: 'https://play.google.com/store/apps/details?id=com.game.kingrush',  //默认地址

    track: 'wittledefender',       //打点名称
    sandbox: null,  //是否是沙盒环境

    email: 'wittledefender@habby.com',
    options: [
        {
            value: 'en',
            label: 'English'
        },
        {
            value: 'ja',
            label: '日本語'
        },
        {
            value: 'ko',
            label: '한국어'
        },
        {
            value: 'zh-TW',
            label: '繁體中文'
        }
    ],
}

// console.log(RE, 'RE');

module.exports = RE;



// WEBPACK FOOTER //
// ./src/assets/replace.js